import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';

const NewProductsWrapper = ({ newProductCount, closeModal }) => {
  const rangeStart = encodeURIComponent(moment().subtract(1, 'weeks').format('MM/DD/YYYY'));
  const rangeEnd = encodeURIComponent(moment().format('MM/DD/YYYY'));
  const searchString = `showInactive=false&startDate=${rangeStart}&endDate=${rangeEnd}`;
  const linkToV2Store = `${window.location.origin}/products/list/search/${searchString}`;
  return (
    <React.Fragment>
      <FormattedMessage
        defaultMessage='<a>{newProductCount} new products</a> have recently been created. You may want to configure these products with default shipping information for future orders.'
        description='new Product alert'
        id='YlF3J5'
        values={{
          newProductCount,
          a: (chunks) => (
            <a href={linkToV2Store} onClick={closeModal}>
              {chunks}
            </a>
          ),
        }}
      />
    </React.Fragment>
  );
};

NewProductsWrapper.propTypes = {
  newProductCount: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export const NewProducts = injectIntl(NewProductsWrapper);
